import { html, LitElement } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { autorun } from 'mobx';

import { store } from '@stores';

import style from './style.css';

@customElement('app-notificator')
export class Notificator extends LitElement {
  static styles = style;

  @state()
  private notifications: INotification[] = [];

  constructor() {
    super();

    autorun(() => {
      this.notifications = store.notificationStore.notifications;
    });
  }

  #renderNotification(notification: INotification) {
    return html`
      <aside class="notification ${notification.level}">
        <button type="button" class="close" @click=${() => store.notificationStore.remove(notification.uuid)}>×</button>
        ${notification.message}
      </aside>
    `;
  }

  render() {
    return html`
      ${this.notifications.map(this.#renderNotification)}
    `;
  }
}
